module.exports = __webpack_public_path__ + "media/images/icons/credit_card/master-a226ec644a3ea5393a1b15cd0fd59fe4.png";